export default {
    superViseDetailListData:{},
    uploadList: [],
    uploadDialogVisible: false,
    theme: localStorage.cly_theme || 'white',
    userMenus: [],
    originUserMenus: [],
}
